import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

const WPCoreGalleryOverlay = (blockElem) => {

	const overlay = blockElem.querySelector('.overlay');

	if(!overlay) {
		return;
	}

	// Capture the link and open the overlay
	const links = blockElem.querySelectorAll('.wp-block-image a');
	if(!links) {
		return;
	}

	const handleLinkClicked = (e) => {
		e.preventDefault();

		let index = e.currentTarget.parentNode.getAttribute('data-swiper-slide-index'); // If the core/gallery is a slideshow...
		if(!index) {
			index = Array.from(e.currentTarget.parentNode.parentNode.children).indexOf(e.currentTarget.parentNode);
		}
		initOverlay(index);
	}

	links.forEach(link => {
		link.addEventListener('click', handleLinkClicked);
	});

	// Check if there's a "view-all-images-btn" that may also trigger the overlay
	const viewAllBtn = blockElem.querySelector('.view-all-images-btn');
	if(viewAllBtn) {
		viewAllBtn.addEventListener('click', (e) => {
			e.preventDefault();
			initOverlay(0);
		});
	}


	// Initialize the overlay. Builds the swiper
	let swiper = null;
	const initOverlay = (index = 0) => {
		if(!swiper) {

			let overlaySlides = '';
			links.forEach(a => {
				overlaySlides += `<div class="swiper-slide"><img src="${a.getAttribute('href')}" alt=""></div>`;
			});
			overlay.querySelector('.swiper-wrapper').innerHTML = overlaySlides;

			swiper = new Swiper(overlay.querySelector('.swiper'), {
				modules: [Navigation, Pagination],
				loop: false,
				slidesPerView: 'auto',
				loopedSlides: 3,
				pagination: {
					el: overlay.querySelector('.pagination'),
					type: 'fraction',
				},
				navigation: {
					nextEl: overlay.querySelector('.swiper-button-next'),
					prevEl: overlay.querySelector('.swiper-button-prev'),
				},
			});

			overlay.querySelector('.close-btn').addEventListener('click', closeOverlay);
		}

		overlay.classList.add('js-active');
		document.body.classList.add('js-core-gallery-overlay');
		blockElem.classList.add('js-overlay-revealed');
		swiper.slideToLoop(index, 1, false);
	};
	const closeOverlay = (e) => {
		if(e) {
			e.preventDefault();
		}
		overlay.classList.remove('js-active');
		document.body.classList.remove('js-core-gallery-overlay');
		blockElem.classList.remove('js-overlay-revealed');
	}
};

export default WPCoreGalleryOverlay;